import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';

import Form from '../../../../../../components/Form/Form';
import Spinner from '../../../../../../components/Spinner';

import './ForgotPassword.scss';

const RequestPasswordMutation = gql`
mutation (
  $Email: String!
) {
    requestPasswordReset(email: $Email) {
    status
  }
}
`;

const mapStateToProps = (state) => ({
    authedUser: state.auth || null,
});

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentValues: {},
            error: null,
            loading: false,
            complete: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
        this.handleOnKey = this.handleOnKey.bind(this);
    }

    handleChange(event) {
        this.setState({
            currentValues: event.target.value,
            error: null,
        });
    }

    handleOnKey(event) {
        switch (event.keyCode) {
            case 13: // Enter
                event.preventDefault();
                this.handleSubmission();
                break;
        }
    }

    handleSubmission() {
        const FormData = this.state.currentValues;

        this.setState({
            loading: true,
        });

        console.log({
            variables: {
                Email: FormData.email,
            },
        })

        this.props.RequestPassword({
            variables: {
                Email: FormData.email,
            },
        })
        .then(() => this.setState({
            loading: false,
            complete: true,
        }));
    }

    render() {
        if (this.state.complete === false) {
            return (
                <div className='ChangePassword__Wrapper'>
                    <Form>
                        <h2 className='FormSegment__title'>Request password reset</h2>
                        {(this.state.error !== null) ? <p className='errorText'>{this.state.error}</p> : null}
                        <Form onChange={this.handleChange}>
                            <div className='row'>
                                <div className='col-md'>
                                    <input type='email' placeholder='Enter your email' onKeyDown={this.handleOnKey} className='Form__Input' name='email' />
                                </div>
                            </div>
                        </Form>
                        <span onClick={this.handleSubmission} className='Button__Submit'>
                            {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Submit'}
                        </span>
                    </Form>
                </div>
            );
        }

        return (
            <div>
                <p style={{ textAlign: 'center', margin: '20px' }}>Password reset requested. Please check your emails</p>
            </div>
        );
    }
}

export default compose(
    graphql(RequestPasswordMutation, {
        name: 'RequestPassword'
    }),
)(connect(mapStateToProps)(ChangePassword));



// WEBPACK FOOTER //
// ./src/routes/user/routes/ForgotPassword/components/ForgotPassword/index.js